export default "__VITE_ASSET__e546a690__"